import React from 'react';
import { motion } from 'framer-motion';
import { THEME } from '../../utils/theme';

const MobileBottomNav = ({ onHome, onStats, onQueue, onRandom, onMore, activeTab, queueCount }) => (
  <motion.nav
    initial={{ y: 100 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.3, ease: 'easeOut' }}
    className="safe-bottom"
    style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '68px',
      background: THEME.glass,
      backdropFilter: 'blur(32px) saturate(180%)',
      WebkitBackdropFilter: 'blur(32px) saturate(180%)',
      borderTop: `1px solid ${THEME.glassBorder}`,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 1000,
      boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.3)'
    }}
  >
    {[
      { icon: '🏠', label: 'Home', action: onHome, active: activeTab === 'home' },
      { icon: '📋', label: 'Queue', action: onQueue, active: activeTab === 'queue', badge: queueCount },
      { icon: '🎲', label: 'Random', action: onRandom, active: activeTab === 'random' },
      { icon: '📊', label: 'Stats', action: onStats, active: activeTab === 'stats' },
      { icon: '⚙️', label: 'More', action: onMore, active: activeTab === 'more' }
    ].map(({ icon, label, action, active, badge }) => (
      <motion.button
        key={label}
        onClick={action}
        whileTap={{ scale: 0.9 }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '4px',
          background: active ? `linear-gradient(135deg, ${THEME.omega}30, ${THEME.supe}30)` : 'transparent',
          border: active ? `1px solid ${THEME.glassBorder}` : 'none',
          borderRadius: '14px',
          padding: '10px 18px',
          cursor: 'pointer',
          transition: 'all 0.2s'
        }}
      >
        <span style={{ fontSize: '22px', position: 'relative' }}>
          {icon}
          {badge > 0 && <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }} style={{ position: 'absolute', top: '-6px', right: '-10px', background: `linear-gradient(135deg, ${THEME.accent}, ${THEME.warning})`, color: '#000', fontSize: '9px', fontWeight: '700', minWidth: '16px', height: '16px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px', boxShadow: `0 2px 8px ${THEME.accent}50` }}>{badge}</motion.span>}
        </span>
        <span style={{
          fontSize: '10px',
          fontWeight: '600',
          color: active ? THEME.text : THEME.textMuted
        }}>{label}</span>
      </motion.button>
    ))}
  </motion.nav>
);

export default MobileBottomNav;
